import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import CommentTicker from "@/components/CommentTicker";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Live from "@/pages/Live";
import LiveComments from "@/pages/LiveComments";
import Clients from "@/pages/Clients";
import Team from "@/pages/Team";
import AuditLog from "@/pages/AuditLog";
import Accounts from "@/pages/Accounts";
import ReviewQueue from "@/pages/ReviewQueue";
import RemovalLog from "@/pages/RemovalLog";
import PassedComments from "@/pages/PassedComments";
import Rules from "@/pages/Rules";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import BrandHealth from "@/pages/BrandHealth";
import PostReports from "@/pages/PostReports";
import Integrations from "@/pages/Integrations";
import ContentStudio from "@/pages/ContentStudio";
import Compliance from "@/pages/Compliance";
import ComingSoon from "@/pages/ComingSoon";

const SOON = {};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <CommentTicker />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/live" element={<ProtectedRoute><Live /></ProtectedRoute>} />
            <Route path="/feed" element={<ProtectedRoute><LiveComments /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute roles={["super_admin"]}><Clients /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute roles={["super_admin", "client_admin"]}><Team /></ProtectedRoute>} />
            <Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />
            <Route path="/review" element={<ProtectedRoute><ReviewQueue /></ProtectedRoute>} />
            <Route path="/passed" element={<ProtectedRoute><PassedComments /></ProtectedRoute>} />
            <Route path="/log" element={<ProtectedRoute><RemovalLog /></ProtectedRoute>} />
            <Route path="/rules" element={<ProtectedRoute><Rules /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute roles={["super_admin", "client_admin"]}><Settings /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
            <Route path="/brand" element={<ProtectedRoute><BrandHealth /></ProtectedRoute>} />
            <Route path="/posts" element={<ProtectedRoute><PostReports /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/integrations" element={<ProtectedRoute roles={["super_admin", "client_admin"]}><Integrations /></ProtectedRoute>} />
            <Route path="/content" element={<ProtectedRoute><ContentStudio /></ProtectedRoute>} />
            <Route path="/compliance" element={<ProtectedRoute><Compliance /></ProtectedRoute>} />
            {Object.entries(SOON).map(([path, [title, desc]]) => (
              <Route key={path} path={`/${path}`} element={<ProtectedRoute><ComingSoon title={title} description={desc} /></ProtectedRoute>} />
            ))}
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
